import React from 'react';
import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  KeyValuePair,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { IconCtaColoredBoxCard } from '@ahc-digital/component-library';
import { CreateIconCTAColoredBoxCardModel } from './C32IconCTAColoredBox.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export type C32IconCTAColoredBoxCardProps = RenderingProps<
  C32IconCTAColoredBoxCardFields,
  {
    TitleType?: string;
  } & DynamicPlaceholderParams &
    TranslationOptionsParams &
    AnchorTargetParams
>;
export type C32IconCTAColoredBoxCardFields = {
  Icon?: KeyValuePair;
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  CardCTA?: LinkField;
};

export const Default = (props?: C32IconCTAColoredBoxCardProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <IconCtaColoredBoxCard
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateIconCTAColoredBoxCardModel(props)}
    />
  );
};
